// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:05:24

export default {
  "id": "find-the-ghost-cat",
  "slug": "find-the-ghost-cat",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3eb7e8a7469345c4ac440b71ef2c84b2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3eb7e8a7469345c4ac440b71ef2c84b2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Find the Ghost Cat",
      "description": "Your mission is to track down elusive ghost cats! These sneaky felines are masters of camouflage, blending into their surroundings, fading into transparency, or hiding in shadows. Stay sharp and see if you can find them all!",
      "instructions": "Use your mouse or touch screen to click on the hidden cat. Be careful—each wrong click costs you one of your three lives! If you're stuck, use the hint button to reveal the cat's location.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "cat",
        "ghost",
        "hidden",
        "point-and-click"
      ]
    },
    "zh-CN": {
      "title": "找到幽灵猫",
      "description": "你的任务是追踪难以捉摸的幽灵猫！这些狡猾的猫咪是伪装大师，能够融入环境，变得半透明，或藏身于阴影中。保持警觉，看看你是否能找到它们全部！",
      "instructions": "使用鼠标或触摸屏点击隐藏的猫。小心——每次错误点击会消耗你的一条生命！如果你卡住了，使用提示按钮来显示猫的位置。",
      "genres": [
        "谜题"
      ],
      "tags": [
        "猫",
        "鬼魂",
        "隐藏",
        "点触式"
      ]
    },
    "zh-TW": {
      "title": "尋找幽靈貓",
      "description": "您的任務是追捕難以捉摸的幽靈貓！這些機靈的貓兒是偽裝的高手，能夠融入環境，變得透明，或躲在陰影中。保持警覺，看看您是否能找到它們全部！",
      "instructions": "使用您的滑鼠或觸控螢幕點擊隱藏的貓咪。小心！每點錯一次會消耗您的一條生命！如果您卡住了，請使用提示按鈕來顯示貓咪的位置。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "貓",
        "幽靈",
        "隱藏",
        "點選式操作"
      ]
    },
    "zh-HK": {
      "title": "尋找幽靈貓",
      "description": "你的任務是追捕難以捉摸的幽靈貓！這些狡猾的貓兒擅長隱形，能夠融入環境，變得透明，或藏匿於陰影之中。保持警覺，看看你能否找到它們全部！",
      "instructions": "使用鼠標或觸控螢幕點擊隱藏的貓咪。小心哦——每一次錯誤點擊都會耗掉你其中一條生命！如果你遇到難題，請使用提示按鈕來揭露貓咪的位置。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "貓",
        "幽靈",
        "隱藏",
        "點擊選擇"
      ]
    },
    "ja": {
      "title": "幽霊猫を見つけろ",
      "description": "あなたのミッションは、見えにくい幽霊猫を追い付くことです！これらの狡猾な猫は、周囲に溶け込む、透明度に消える、または影に隠れるカモフラージュの達人です。鋭い目を持ち、すべてを見つけることができるか試してみてください！",
      "instructions": "マウスやタッチスクリーンを使って隠れた猫をクリックしてください。注意してください—間違ったクリックはあなたの3つのライフの1つを失います！もし迷ったら、ヒントボタンを使って猫の場所を表示してください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "猫",
        "幽霊",
        "隠れ",
        "ポインとクリック"
      ]
    },
    "ko": {
      "title": "고스트 고양이 찾기",
      "description": "귀하의 임무는 피고픈 유령 고양이를 추적하는 것입니다! 이들 속삭이는 고양이들은 은신술의 마스터로, 주변 환경에 스며들거나 투명해지거나 그림자 속에 숨는 것을 전문으로 합니다. 신비하게 유지하고 모두를 찾을 수 있는지 확인해 보세요!",
      "instructions": "마우스나 터치스크린을 사용하여 숨겨진 고양이를 클릭하세요. 주의하세요—잘못된 클릭은 세 명의 생명 중 하나를 소비합니다! 막힐 때, 고양이 위치를 표시하는 힌트 버튼을 사용하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "고양이",
        "귀신",
        "숨겨진",
        "포인트 앤 클릭"
      ]
    },
    "fr": {
      "title": "Trouvez le Chat Fantôme",
      "description": "Votre mission est de traquer des chats fantômes évasifs ! Ces félins rusés sont maîtres de la camouflade, se fondant dans leur environnement, s'estompant en transparence ou se cachant dans l'ombre. Restez vigilant et voyez si vous pouvez les trouver tous !",
      "instructions": "Utilisez votre souris ou l'écran tactile pour cliquer sur le chat caché. Soyez prudent - chaque clic incorrect vous coûte une de vos trois vies ! Si vous êtes bloqué, utilisez le bouton indice pour révéler la position du chat.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "chat",
        "fantôme",
        "caché",
        "clic-droit"
      ]
    }
  }
};
